import { z } from "zod";
import { zString } from "./commonSchemaObjects";

export const codelistValueSchema = z.object({
  code_list_value_code: zString.zRequired,
  code_submission_value: zString.zRequired,
  code_list_value: zString.zRequired,
  code_value_definition: zString.zRequired,
});
